export * from './SyntheticDOM';


//////////////////
// WEBPACK FOOTER
// ./node_modules/synthetic-dom/esm/main.js
// module id = 1603
// module chunks = 0